import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../index';
import { ContactService } from '../../data/contact.service';
import {
    contactEditorEdit,
    contactEditorLoadComplete, contactEditorLoadFailure,
    contactEditorLoadRequest, contactEditorNew,
    contactEditorSaveFailure,
    contactEditorSaveRequest, contactEditorSaveSuccess
} from './contact-editor.actions';
import { catchError, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { selectContactEditorState } from './contact-editor.state';
import { of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ContactEditComponent } from '../../modules/address-books/contact-edit/contact-edit.component';

@Injectable()
export class ContactEditorEffects {

    constructor(private actions$: Actions, private store: Store<AppState>, private contactService: ContactService,
                private dialog: MatDialog) {
    }

    contactEditorLoader$ = createEffect(() => this.actions$.pipe(
        ofType(contactEditorLoadRequest),
        switchMap((action) => this.contactService.getByKey(action.id).pipe(
            map((contact) => contactEditorLoadComplete({ contact })),
            catchError(() => of(contactEditorLoadFailure()))
        ))
    ));

    contactEditorUpdate$ = createEffect(() => this.actions$.pipe(
        ofType(contactEditorSaveRequest),
        withLatestFrom(this.store.select(selectContactEditorState)),
        map(([ _, state ]) => ({
                id: state.id,
                reference: state.reference,
                addressBookId: state.addressBookId,
                card: state.card
            })),
        filter(contact => contact.id !== null),
        switchMap((contact) => this.contactService.update(contact).pipe(
            map(() => contactEditorSaveSuccess()),
            catchError(() => of(contactEditorSaveFailure()))
        ))
    ));

    contactEditorCreate$ = createEffect(() => this.actions$.pipe(
        ofType(contactEditorSaveRequest),
        withLatestFrom(this.store.select(selectContactEditorState)),
        map(([ _, state ]) => ({
            id: state.id,
            reference: state.reference,
            addressBookId: state.addressBookId,
            card: state.card,
            addressBookName: null
        })),
        filter(contact => contact.id === null),
        switchMap((contact) => this.contactService.add(contact).pipe(
            map(() => contactEditorSaveSuccess()),
            catchError(() => of(contactEditorSaveFailure()))
        ))
    ));

    contactEditorNew$ = createEffect(() => this.actions$.pipe(
        ofType(contactEditorNew),
        tap(() => this.dialog.open(ContactEditComponent))
    ), { dispatch: false });

    contactEditorEdit$ = createEffect(() => this.actions$.pipe(
        ofType(contactEditorEdit),
        tap(() => this.dialog.open(ContactEditComponent, { panelClass: 'modal-editor', data: { edit: true } })),
        map((action) => contactEditorLoadRequest({ id: action.id }))
    ));
}
